module.exports = __webpack_public_path__ + "img/xmk.f850c0db.png";